import { getLink } from '@/api/link';
import $ from 'jquery';
import manager from '../manager';

manager.add('link', function (...arg) {
	var url = getLink(...arg)
	if (this.dom.tagName == 'A' || this.dom.tagName == 'AREA') {
		$(this.dom).attr('href', url)
	} else {
		$(this.dom).attr('src', url)
	}
})